import React from "react";
import { Link } from "react-router-dom";

const wrap = { maxWidth: 1080, margin: "0 auto", padding: "0 24px" };
const eyebrow = { fontSize: 11, color: "var(--text-faint)", fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 };
const h2 = { fontSize: 20, fontWeight: 700, marginBottom: 20, color: "var(--text-main)" };
const box = { background: "var(--bg-surface)", border: "1px solid var(--border)", borderRadius: "var(--radius-xl)", padding: "32px 36px" };
const nums = (n) => Array.from({ length: n }, (_, i) => i + 1);
const isOpen = (partner) => !(partner && partner.signup && partner.signup.providerMode === "appointed");
const btn1 = { padding: "11px 24px", borderRadius: "var(--radius-md)", background: "var(--accent)", color: "#fff", fontSize: 14, fontWeight: 600, border: "none", cursor: "pointer", textDecoration: "none" };
const btn2 = { padding: "10px 18px", borderRadius: "var(--radius-md)", background: "transparent", border: "1px solid var(--border)", color: "var(--text-muted)", fontSize: 13, cursor: "pointer", textDecoration: "none" };

export function PartnerHero({ landing: L, appName, partner, isLoggedIn, dashboardPath, navigate }) {
  const hasTitle = L["hero.title1"] || L["hero.title2"];
  const t1 = hasTitle ? L["hero.title1"] : "Welcome to";
  const t2 = hasTitle ? L["hero.title2"] : appName;
  const checks = nums(3).map((i) => L["hero.check" + i]).filter(Boolean);
  return (
    <div>
      {L["hero.badge"] && (
        <div style={{ display: "inline-flex", alignItems: "center", background: "var(--accent-soft)", border: "1px solid var(--accent-border)", borderRadius: "var(--radius-full)", padding: "4px 14px", fontSize: 11, color: "var(--accent)", marginBottom: 20 }}>{L["hero.badge"]}</div>
      )}
      <h1 style={{ fontSize: 38, fontWeight: 800, lineHeight: 1.1, margin: "0 0 14px", letterSpacing: "-0.03em" }}>
        {t1}{t1 && t2 ? <br /> : null}
        <span style={{ color: "var(--accent)" }}>{t2}</span>
      </h1>
      {L["hero.text"] && <p style={{ fontSize: 13, color: "var(--text-muted)", maxWidth: 420, lineHeight: 1.75, margin: "0 0 12px" }}>{L["hero.text"]}</p>}
      {L["hero.quote"] && <p style={{ fontSize: 12, color: "var(--accent)", fontWeight: 600, fontStyle: "italic", margin: "0 0 12px" }}>{L["hero.quote"]}</p>}
      {L["hero.pill"] && (
        <div style={{ display: "inline-flex", fontSize: 10, color: "var(--text-faint)", background: "var(--bg-surface)", border: "1px solid var(--border)", borderRadius: "var(--radius-full)", padding: "3px 10px", marginBottom: 16 }}>{L["hero.pill"]}</div>
      )}
      {checks.length > 0 && (
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", marginBottom: 22 }}>
          {checks.map((t, k) => (<span key={k} style={{ fontSize: 12, color: "var(--text-muted)" }}>{"\u2713 " + t}</span>))}
        </div>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
        <button onClick={() => navigate(isLoggedIn ? dashboardPath : "/register?role=investor")} style={btn1}>{L["hero.btn1"] || "Join as Investor"}</button>
        {isOpen(partner) && <button onClick={() => navigate(isLoggedIn ? dashboardPath : "/register")} style={btn2}>{L["hero.btn2"] || "I'm a Trader / Analyst"}</button>}
      </div>
      {L["hero.note"] && <p style={{ fontSize: 12, color: "var(--text-faint)", marginBottom: 16 }}>{L["hero.note"]}</p>}
    </div>
  );
}

export function PartnerSections({ landing: L }) {
  const has = (...ks) => ks.some((k) => L[k]);
  const small = { fontSize: 12, color: "var(--text-muted)", lineHeight: 1.7 };
  return (
    <>
      {L["problem.title"] && (
        <section style={{ ...wrap, margin: "48px auto 0" }}>
          <div style={box} className="problem-box">
            {L["problem.eyebrow"] && <div style={eyebrow}>{L["problem.eyebrow"]}</div>}
            <div style={h2}>{L["problem.title"]}</div>
            {L["problem.intro"] && <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.7, marginBottom: 16 }}>{L["problem.intro"]}</p>}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 10 }}>
              {nums(4).filter((i) => has("problem.bad" + i, "problem.fix" + i)).map((i) => (
                <div key={i} style={{ borderRadius: "var(--radius-lg)", overflow: "hidden", border: "1px solid var(--border)" }}>
                  {L["problem.bad" + i] && <div style={{ ...small, padding: "10px 14px", background: "var(--danger-soft)", borderBottom: "1px solid var(--border)" }}>{L["problem.bad" + i]}</div>}
                  {L["problem.fix" + i] && <div style={{ ...small, padding: "10px 14px", background: "var(--success-soft)" }}>{L["problem.fix" + i]}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      {L["solution.title"] && (
        <section style={{ ...wrap, margin: "20px auto 0" }}>
          <div style={box} className="problem-box">
            {L["solution.eyebrow"] && <div style={eyebrow}>{L["solution.eyebrow"]}</div>}
            <div style={h2}>{L["solution.title"]}</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 20 }}>
              {nums(4).filter((i) => has("solution.t" + i, "solution.d" + i)).map((i) => (
                <div key={i}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text-main)", marginBottom: 6 }}>{L["solution.t" + i]}</div>
                  <div style={small}>{L["solution.d" + i]}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      {L["how.title"] && (
        <section id="how" style={{ ...wrap, margin: "48px auto 0" }}>
          {L["how.eyebrow"] && <div style={eyebrow}>{L["how.eyebrow"]}</div>}
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>{L["how.title"]}</div>
          <div className="steps-grid" style={{ marginBottom: 40 }}>
            {nums(3).filter((i) => has("how.t" + i, "how.d" + i)).map((i) => (
              <div key={i} style={{ background: "var(--bg-surface)", borderRadius: "var(--radius-xl)", padding: 20, border: "1px solid var(--border)" }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: "var(--accent-soft)", border: "1px solid var(--accent-border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "var(--accent)", marginBottom: 14 }}>{i}</div>
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8, color: "var(--text-main)" }}>{L["how.t" + i]}</div>
                <div style={small}>{L["how.d" + i]}</div>
              </div>
            ))}
          </div>
        </section>
      )}
      {L["roles.title"] && (
        <section style={{ ...wrap, margin: L["how.title"] ? "0 auto" : "48px auto 0" }}>
          {L["roles.eyebrow"] && <div style={eyebrow}>{L["roles.eyebrow"]}</div>}
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 6 }}>{L["roles.title"]}</div>
          {L["roles.sub"] && <div style={{ fontSize: 14, color: "var(--text-muted)", marginBottom: 28, maxWidth: 500, lineHeight: 1.7 }}>{L["roles.sub"]}</div>}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16, marginTop: 20 }}>
            {["inv", "tr", "an"].filter((c) => L["roles." + c + ".head"]).map((c) => (
              <div key={c} style={{ background: "var(--bg-surface)", borderRadius: "var(--radius-xl)", padding: 20, border: "1px solid var(--border)" }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: "var(--accent)", marginBottom: 4 }}>{L["roles." + c + ".head"]}</div>
                {L["roles." + c + ".sub"] && <div style={{ fontSize: 11, color: "var(--text-faint)", marginBottom: 16, lineHeight: 1.5 }}>{L["roles." + c + ".sub"]}</div>}
                <ul style={{ fontSize: 12, color: "var(--text-muted)", paddingLeft: 16, lineHeight: 2, margin: 0 }}>
                  {nums(5).map((i) => L["roles." + c + ".b" + i]).filter(Boolean).map((t, k) => (<li key={k}>{t}</li>))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
}

export function PartnerCta({ landing: L, appName, partner, isLoggedIn, dashboardPath }) {
  return (
    <section style={{ ...wrap, margin: "48px auto 0", padding: "0 24px 64px" }}>
      <div style={{ background: "var(--accent-soft)", border: "1px solid var(--accent-border)", borderRadius: "var(--radius-xl)", padding: "48px 32px", textAlign: "center" }}>
        <div style={{ fontSize: 28, fontWeight: 700, marginBottom: L["cta.text"] ? 12 : 28, color: "var(--text-main)", letterSpacing: "-0.02em" }}>{L["cta.title"] || "Join " + appName}</div>
        {L["cta.text"] && <div style={{ fontSize: 14, color: "var(--text-muted)", maxWidth: 400, margin: "0 auto 28px", lineHeight: 1.7 }}>{L["cta.text"]}</div>}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <Link to={isLoggedIn ? dashboardPath : "/register?role=investor"} style={btn1}>{L["cta.btn1"] || "Join as Investor"}</Link>
          {isOpen(partner) && <Link to={isLoggedIn ? dashboardPath : "/register"} style={btn2}>{L["cta.btn2"] || "I'm a Trader / Analyst"}</Link>}
        </div>
      </div>
    </section>
  );
}

export function PartnerFooter({ appName, footerText, landing: L }) {
  const links = [["footer.about", "About Us"], ["footer.terms", "Terms"], ["footer.privacy", "Privacy"], ["footer.risk", "Risk Disclosure"]].filter(([k]) => L[k]);
  return (
    <footer style={{ borderTop: "1px solid var(--border-subtle)", padding: "24px", maxWidth: 1080, margin: "0 auto", fontSize: 11, color: "var(--text-faint)" }}>
      <div className="footer-inner">
        <div>
          <span style={{ fontWeight: 700, color: "var(--text-main)" }}>{appName}</span>
          {" "}{"\u00a9 " + new Date().getFullYear()}{footerText ? " \u00b7 " + footerText : ""}
        </div>
        {links.length > 0 && (
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {links.map(([k, label]) => (<a key={k} href={L[k]} target="_blank" rel="noopener noreferrer" style={{ color: "var(--text-faint)", textDecoration: "none" }}>{label}</a>))}
          </div>
        )}
      </div>
    </footer>
  );
}
